import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { SETTINGDEFINITION } from '../../../../constants/applicationConstants';
import {
  DataTableHoc,
  Loader,
  ErrorFallback,
  deleteFilter,
  applyFilter,
  saveFilters,
} from 'smart-react';
import { GridColumnsList } from '../Components/Filter/FilterElements';
import DataColumns from '../Components/DataColumns/DataColumns';
import {
  ROW_LAYOUTS,
  PAGE_SIZE,
} from '../../../../constants/applicationConstants';
const BaseDataTable = React.lazy(
  () => import('../Components/DataTable/DataTable'),
);
const SettingDefinitionDataTable = DataTableHoc(BaseDataTable);

/**
 * Setting Definition main screen
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The Setting Definition component.
 */
const SettingDefinition = ({ connectionType }) => {
  const [userData, setUserData] = React.useState([]);
  const dataColumnsArray = DataColumns({});
  // used to check API is ready to call
  const [isReady, setIsReady] = React.useState(false);

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // reset the state of your app so the error doesn't happen again
      }}
    >
      <div className='container mx-auto k-px-4'>
        <React.Suspense fallback={<Loader />}>
          <SettingDefinitionDataTable
            deleteFilter={deleteFilter}
            applyFilter={applyFilter}
            saveFilters={saveFilters}
            moduleName={SETTINGDEFINITION}
            dataColumns={dataColumnsArray}
            gridColumnsList={GridColumnsList}
            dataTableName={SETTINGDEFINITION}
            setIsReady={setIsReady}
            isReady={isReady}
            rowLayoutConfigName={`${SETTINGDEFINITION}.DataGrid.RowLayout`}
            pageLengthConfigName={`${SETTINGDEFINITION}.DataGrid.ItemsPerPage`}
            dataSet={userData}
            setDataSet={setUserData}
            isCardonMobileView={false}
            total={process.env.DefaultLimit}
            defaultRowLayout={process.env.RowLayout}
            rowLayouts={ROW_LAYOUTS}
            pageSizes={PAGE_SIZE}
            contentSliderTitle={'Setting Definition'}
            connectionType={connectionType}
          />
        </React.Suspense>
      </div>
    </ErrorBoundary>
  );
};
export default SettingDefinition;
